<template>
  <section v-if="notificationShow" class="notification-wrap">
    <section
      class="notification"
      :class="{ 'notification--error': notificationType === 'error' }"
    >
      <span class="title">
        Notification
        <button
          @click="updateMsg(false)"
          aria-label="Close"
          type="button"
          class="exit-btn"
        >
          X
        </button>
      </span>
      <h4 v-html="notificationMsg"></h4>
    </section>
  </section>
</template>

<script>
import { useNotification } from "@/helpers/notification";
export default {
  setup() {
    const {
      notificationShow,
      notificationMsg,
      notificationType,
    } = useNotification();

    function updateMsg(truthy) {
      notificationShow.value = truthy;
    }

    return {
      notificationShow,
      notificationMsg,
      notificationType,
      updateMsg,
    };
  },
};
</script>

<style lang="scss" scoped>
.exit-btn {
  background: none;
  border: none;
  color: var(--white);
  padding: 0;
  position: absolute;
  right: 8px;
  top: 8px;
  &:hover {
    cursor: pointer;
  }
}
.notification-wrap {
  bottom: 0;
  left: 50%;
  max-width: 1200px;
  position: fixed;
  transform: translate3d(-50%, 0, 0);
  width: 100%;
  z-index: 99;
}
.notification {
  background-color: #6faa41bd;
  backdrop-filter: blur(10px);
  bottom: 24px;
  border: 1px solid var(--light-grey);
  color: var(--white);
  -webkit-box-shadow: 1px 2px 5px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 1px 2px 5px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 1px 2px 5px 0px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  right: 0px;
  margin: 0;
  max-width: 320px;
  min-width: 200px;
  position: absolute;
  z-index: 99999;
  h4 {
    color: var(--white);
    margin: 0;
    padding: 16px 16px;
  }
  @media screen and (max-width: 420px) {
    right: 0;
    bottom: 8px;
  }
}
.notification {
  color: var(--white);
  h4 {
    color: var(--white);
    font-size: 15px;
  }
}
.notification.notification--error {
  background-color: hsla(356, 82%, 49%, 0.8);
  font-size: 14px;

  & >>> a {
    text-decoration: underline;
  }
}
.title {
  border-bottom: 1px solid #6faa41;
  color: var(--white);
  display: block;
  font-size: 12px;
  padding: 8px 16px;
  position: relative;
}
.notification.notification--error {
  .title {
    border-bottom: 1px solid hsla(356, 82%, 49%, 1);
  }
}
</style>
